var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('div',{staticClass:"logo-content",on:{"click":_vm.logoClick}},[_c('p',{staticClass:"protalName"},[_vm._v("微能力“四应用”活动")])])])}
var staticRenderFns = []

export { render, staticRenderFns }